import React, { useState } from "react";
import { useHistory } from "react-router";
import { Row, Col, Typography, Button } from "antd";
import Buyer from "../../../../assets/images/buyer-activity.svg";
import Shortlisted from "../../../../assets/images/shortlisted.svg";
import Hovered from "../../../../assets/images/account-hover.svg";
import moment from "moment";
import { removeProduct } from "redux/actions/productActions";
const { Text, Title } = Typography;

export default function CatalogueDetails(props) {
  const history = useHistory();
  const { status, buyer_activity={}, index, details } = props;
 const { date = "", name = "" } = buyer_activity;
 
  const [btnName, setBtnName] = useState("");
  const [hover, setHover] = useState(false);

  const handleHover = () => {
    setBtnName("View activity");
    setHover(true);
  };

  const removeHover = () => {
    setBtnName(getActivityText(buyer_activity.action));
    setHover(false);
  };
  const getActivityText = (actionType) => {
    let text = "";
    switch (actionType) {
      case "link_open":
        text = "Opened link";
        break;
      case "send_query":
        text = "Sent query";
        break;
      case "shortlist_product":
        text = "Shortlisted";
        break;
    }
    return (
      <Text strong className="activity-button-text">
        {text}
      </Text>
    );
  };
  const handleClick = (e) => {
    history.push(`/buyer-activity-details/${details.collection_link}`);
  };
  return (
    <Row>
      <Col>
        <Row>
          <Col style={{ marginTop: date ? "25px" : "0" }}>
            {status !== "draft" && buyer_activity.action ? (
              <>
                <Row justify="center">
                  <Button
                    size="large"
                    type="ghost"
                    className={`buyer-activity-btn ${
                      buyer_activity.action === "send_query"
                        ? ""
                        : "shortlisted"
                    }`}
                    onMouseOver={() => handleHover()}
                    onMouseLeave={() => removeHover()}
                    onClick={handleClick}
                    // style={{ borderColor: "#d9d9d9" }}
                  >
                    {
                      <>
                        <Row gutter={[16, 16]} justify="space-between">
                          <Col>
                            <img
                            alt="send_query"
                              style={{
                                "margin-top": "2px",
                              }}
                              className="activity-icon"
                              src={
                                hover
                                  ? Hovered
                                  : buyer_activity.action === "send_query"
                                  ? Buyer
                                  : Shortlisted
                              }
                            />
                          </Col>
                          <Col
                            style={{
                              width: "100px",
                              padding: "0 20px 0 0",
                              marginTop: "2px",
                            }}
                          >
                            {btnName || getActivityText(buyer_activity.action)}
                          </Col>
                        </Row>
                      </>
                    }
                  </Button>
                </Row>

                {date && (
                  <Row justify="center">
                    <Text
                      type="secondary"
                      style={{ padding: "5px 0 0 0", fontSize: "12px" }}
                    >
                      On {moment(new Date(date)).format("Do MMM' YY, h:mm a")}
                    </Text>
                  </Row>
                )}
              </>
            ): <Row style={{display:'flex',flexDirection:'row', justifyContent:'center',alignContent:'center',width:'10em'}}><Col>- - -</Col> </Row>}
            {/* {status}
            {JSON.stringify(buyer_activity)} */}
            {/* <Title level={5} style={{ margin: 0 }}>
              {text?.name}
            </Title> */}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
